import { PushNotifications } from '@capacitor/push-notifications';

// tokenGetter: async () => string|null
export async function initNativePush(apiBase, tokenGetter) {
  const perm = await PushNotifications.requestPermissions();
  if (perm.receive !== 'granted') return;

  await PushNotifications.register();

  PushNotifications.addListener('registration', async ({ value }) => {
    const authToken = await tokenGetter?.();
    if (!authToken) { console.warn('No auth token available for push registration'); return; }
    await fetch(`${apiBase}/api/mobile-push/tokens`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`
      },
      body: JSON.stringify({
        platform: 'android',
        token: value,
        appId: 'com.ekkos.app'
      })
    });
  });

  PushNotifications.addListener('registrationError', (err) => {
    console.error('Push registration error', err);
  });

  PushNotifications.addListener('pushNotificationReceived', (n) => {
    console.log('Push received', n);
  });
}

export async function unregisterNativePush(apiBase, authToken, token) {
  await fetch(`${apiBase}/api/mobile-push/tokens`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`
    },
    body: JSON.stringify({
      platform: 'android',
      token
    })
  });
}
